<script>
  import Header from '~/Components/Organisms/Header'
  import Footer from '~/Components/Organisms/Footer'
  import Wrap from '~/Components/Layout/Wrap'
</script>

<div class="app">

  <Wrap>

    <Header />

  </Wrap>

  <Wrap grow={true}>

    <slot />

  </Wrap>

  <Footer />

</div>

<style lang="scss">
  .app {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
  }
</style>